import React from "react";
import HorizontalStack from "./util/HorizontalStack";
import UserAvatar from "./UserAvatar";
import { Typography, Button, Box, useTheme } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { isLoggedIn } from "../helpers/authHelper";

const UserEntry = ({ username, user }) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const currentUser = isLoggedIn();

  const handleMessage = () => {
    if (!currentUser) {
      navigate("/login");
      return;
    }
    
    // Navigate to messenger with user data
    const userData = user || { username, _id: user?._id || username };
    navigate("/messenger", { 
      state: { 
        user: userData
      } 
    });
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        py: 1.5,
        px: 1,
        borderRadius: "12px",
        "&:hover": {
          backgroundColor: "rgba(0,0,0,0.02)",
        },
        transition: "background-color 0.2s ease",
      }}
    >
      <HorizontalStack spacing={1.5}>
        <UserAvatar width={48} height={48} username={username} />
        <Box>
          <Typography
            variant="body2"
            sx={{
              fontWeight: 600,
              color: "text.primary",
            }}
          >
            {username}
          </Typography>
        </Box>
      </HorizontalStack>
      <Button
        onClick={handleMessage}
        variant="contained"
        size="small"
        sx={{
          borderRadius: "12px",
          px: 2,
          py: 0.5,
          textTransform: "none",
          fontWeight: 600,
          fontSize: "0.75rem",
          background: "linear-gradient(135deg, #7C3AED 0%, #A855F7 100%)",
          boxShadow: "0 2px 6px rgba(124,58,237,0.25)",
          "&:hover": {
            background: "linear-gradient(135deg, #6D28D9 0%, #9333EA 100%)",
            boxShadow: "0 4px 10px rgba(124,58,237,0.35)",
          },
        }}
      >
        Message
      </Button>
    </Box>
  );
};

export default UserEntry;
